import styled, { css } from 'styled-components'
import { device } from '../../../styles/GlobalVariables'
import { AD_WIDTH, AD_HEIGHT } from './TopBannerMobile'

// Reserves the banner's layout space via CSS (before device/ad detection resolves
// on the client) so mounting the real ad never shifts the page. On mobile the
// reserved space is a fixed aspect-ratio, independent of the ad actually served.
export const TopBannerFrame = styled.div<{ dfpIsBlocked?: boolean }>`
  width: 100%;
  position: relative;

  ${({ dfpIsBlocked }) =>
    dfpIsBlocked
      ? css`
          display: none;
        `
      : css`
          aspect-ratio: ${AD_WIDTH} / ${AD_HEIGHT};

          ${device.regular} {
            aspect-ratio: unset;
            min-height: 290px;
          }
        `}
`
